import React from "react";
import { Box, Typography } from "components/ui/MaterialAdapter";
import { Flag } from "components/ui/IconAdapter";

const QuestionNumbersBox = ({
  questionList,
  currentPage,
  selectedAnswersList,
  markedQuestions = [],
  handleQuestionNumberClick,
  colors
}) => {
  const handleQuestionClick = (index) => {
    handleQuestionNumberClick(index);
  };

  const getQuestionStatus = (index) => {
    if (markedQuestions.includes(index)) return 'marked';
    if (selectedAnswersList[index]) return 'answered';
    return 'unanswered';
  };

  const renderQuestionNumbers = () => {
    return questionList.map((question, index) => {
      const status = getQuestionStatus(index);
      const isCurrent = currentPage === index;
      
      return (
        <Box
          key={index}
          onClick={() => handleQuestionClick(index)}
          sx={{
            width: 50,
            height: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 2,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            position: 'relative',
            border: isCurrent ? `2px solid ${colors.primary}` : `1px solid ${colors.border}`,
            backgroundColor: 
              status === 'answered' ? colors.success :
              status === 'marked' ? colors.warning :
              colors.background, // Changed from colors.surface to colors.background
            color: 
              status === 'answered' ? 'white' :
              status === 'marked' ? 'white' :
              colors.textPrimary,
            fontWeight: 600,
            fontSize: '0.9rem',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              borderColor: colors.primary
            }
          }}
        >
          {index + 1}
          {status === 'marked' && (
            <Flag 
              sx={{ 
                position: 'absolute',
                top: -4,
                right: -4,
                fontSize: 16,
                color: colors.warning,
                backgroundColor: colors.background, // Changed from white to colors.background
                borderRadius: '50%',
                padding: '2px'
              }} 
            />
          )}
        </Box>
      );
    });
  };

  const renderQuestionRows = () => {
    const rows = [];
    const itemsPerRow = 4;
    
    for (let i = 0; i < questionList.length; i += itemsPerRow) {
      rows.push(
        <Box 
          key={`row-${i}`} 
          sx={{ 
            display: 'flex', 
            gap: 1.5, 
            mb: 1.5,
            justifyContent: 'flex-start'
          }}
        >
          {renderQuestionNumbers().slice(i, i + itemsPerRow)}
        </Box>
      );
    }
    return rows;
  };

  return (
    <Box>
      {/* Question Grid */}
      <Box sx={{ mb: 3 }}>
        {renderQuestionRows()}
      </Box>
      <Box sx={{ p: 2, backgroundColor: colors.background, borderRadius: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: colors.textPrimary }}>
          Legend
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ width: 16, height: 16, borderRadius: 1, backgroundColor: colors.success }} />
            <Typography variant="caption" sx={{ color: colors.textSecondary }}>
              Answered
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ width: 16, height: 16, borderRadius: 1, backgroundColor: colors.warning }} />
            <Typography variant="caption" sx={{ color: colors.textSecondary }}>
              Marked for review
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ width: 16, height: 16, borderRadius: 1, backgroundColor: colors.background, border: `1px solid ${colors.border}` }} />
            <Typography variant="caption" sx={{ color: colors.textSecondary }}>
              Unanswered
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ width: 16, height: 16, borderRadius: 1, border: `2px solid ${colors.primary}`, backgroundColor: 'transparent' }} />
            <Typography variant="caption" sx={{ color: colors.textSecondary }}>
              Current question
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default QuestionNumbersBox;